import type { TFunction } from "i18next";
import { formatDateTime } from "../../../lib/datetime/displayDateTime";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { optionLabel } from "../../../lib/i18n/optionLabel";

export const getSourceSystemCols = (t: TFunction) => [
  {
    name: t("sourceSystems.cols.name"),
    selector: (row: any) => row.name,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.logo"),
    selector: (row: any) => row.logo,
    sortable: false,
    cell: (row: any) =>
      row.logo ? (
        <Box
          component="img"
          src={`data:image/png;base64,${row.logo}`}
          alt={row.name}
          sx={{ width: 40, height: 40, objectFit: "contain", borderRadius: 1 }}
        />
      ) : (
        <Box
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "action.hover",
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {t("common.noLogo")}
          </Typography>
        </Box>
      ),
  },
  {
    name: t("sourceSystems.cols.status"),
    selector: (row: any) => row.status,
    sortable: true,
    cell: (row: any) => (
      <Chip
        label={optionLabel(t, "options.entityStatus", row.status)}
        size="small"
        color={row.status === "ACTIVE" ? "success" : "error"}
      />
    ),
  },
  {
    name: t("sourceSystems.cols.contacts"),
    selector: (row: any) => row.contacts?.length || 0,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.sources"),
    selector: (row: any) => row.sources?.length || 0,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.createdBy"),
    selector: (row: any) => row.createdBy,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.createdDate"),
    selector: (row: any) => formatDateTime(row.createdDate),
    sortable: true,
  },
];

const SourceSystemModel = {
  get cols() {
    return getSourceSystemCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("sourceSystems.createTitle"),
    content: t("sourceSystems.createContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("sourceSystems.editTitle"),
    content: t("sourceSystems.editContent"),
  }),
  WARNING: {
    color: "warning",
    icon: "warning",
    title: "",
    content: "",
    info: "",
  },
  ERROR: {
    color: "error",
    icon: "error",
    title: "",
    content: "",
    info: "",
  },
  SUCCESS: {
    color: "success",
    icon: "success",
    title: "",
    content: "",
    info: "",
  },
  async message(type: any, title: any, content: any, info: any) {
    return new Promise((resolve) => {
      type.title = title;
      type.content = content;
      type.info = info;
      resolve(type);
    });
  },
};

export default SourceSystemModel;
